var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-play 1",
    clipPath: "url(#clip0_462_2932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0738 9.84528L2.15251 19.7665C1.67824 19.3179 1.42188 18.7026 1.42188 18.0361V2.47484C1.42188 1.79548 1.69106 1.1802 2.17815 0.71875L12.0738 9.84528Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.6457 10.2553C20.6457 11.1525 20.1586 11.9473 19.351 12.3959L16.531 13.9597L13.0317 10.7295L12.0703 9.84507L15.7748 6.14062L19.351 8.11462C20.1586 8.56326 20.6457 9.35798 20.6457 10.2553Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0714 9.84781L2.17578 0.721281C2.30396 0.5931 2.4706 0.477736 2.63724 0.375191C3.44478 -0.111899 4.41896 -0.124717 5.25214 0.336737L15.7758 6.14336L12.0714 9.84781Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.5304 13.9584L5.25043 20.1752C4.85307 20.4059 4.40443 20.5085 3.96862 20.5085C3.50716 20.5085 3.04571 20.3931 2.63553 20.1367C2.45607 20.0342 2.28944 19.906 2.14844 19.765L12.0697 9.84375L13.0311 10.7282L16.5304 13.9584Z",
    fill: "#F44336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_462_2932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.5125,
    height: 20.5125,
    fill: "white",
    transform: "translate(0.777344)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGplay);
export default __webpack_public_path__ + "static/media/gplay.369bc2c751a1fe987d8e9da6a2fa79a8.svg";
export { ForwardRef as ReactComponent };